export default __webpack_public_path__ + "static/01-Cervejas--dd74c5018e68bc72ab36b37033787841.jpg";